import gql from 'graphql-tag';

import { FEED_POST_DETAILS_FRAGMENT } from '../fragments/Post/feedPostDetails';

export const GET_POSTS_QUERY = gql`
  query GetPosts(
    $cursor: String
    $plexIds: [String!]!
    $types: [PostType!]!
    $publishStatuses: [PublishStatus!]!
    $labelIds: [String!]!
  ) {
    posts(
      cursor: $cursor
      limit: 10
      timeOrder: DESC
      filters: { plexIds: $plexIds, types: $types, publishStatuses: $publishStatuses, labelIds: $labelIds }
    ) {
      items {
        ...feedPostDetails
      }
      nextCursor
    }
  }

  ${FEED_POST_DETAILS_FRAGMENT}
`;

export { useGetPostsQuery } from '../gen/types';
